export default function (state = [{_id: 0, title: 'Nenhum bot encontrado!!', lastUpdate: new Date()}], action) {
	switch (action.type) {
		case 'LIST_BOTS':
			return action.payload;
		default:
			return state;
	}
}